import classNames from "classnames";
import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { faArrowLeft, faClose } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "@edgetier/components";
import type { IProps } from "./back-button.types";
import "./back-button.scss";

/**
 * A go back button using relative paths to navigate back.
 * @param props.children  Button content
 * @param props.className Optional extra class name(s) to add.
 * @param props.styleName Optional style name for the button.
 * @param props.backToText Optional text to display when navigating back.
 * @param props.closeTabText Optional text to display when closing the tab.
 * @returns               BackButton component.
 */
const BackButton: FunctionComponent<IProps> = ({
    children,
    className,
    styleName = "positive",
    icon,
    backToText = "Back",
    closeTabText = "Close Review",
}) => {
    const navigate = useNavigate();
    return (
        <Button
            data-testid="back-button"
            outline
            styleName={styleName}
            icon={icon || window.history.length > 1 ? faArrowLeft : faClose}
            onClick={() => (window.history.length > 1 ? navigate(-1) : window.close())}
            className={classNames("back-button", className)}
        >
            {children || (window.history.length > 1 ? backToText : closeTabText)}
        </Button>
    );
};

export default BackButton;
